import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom"
import style from './channels.module.scss';
import Button from "../Button/button";
import ChannelsCard from "./channelsCard/channelsCard";
import MobileChannelsCard from "./mobileChannelsCard/mobileChannelsCard"
import Modal from "../Modal/Modal";
import check from "../../assets/testIcon/checked.svg"
import Toast from "../Toast/Toast";
import EmailRegex from "../../helpers/actions/emailRegex";
import PhoneNumberRegex from '../../helpers/actions/phoneNumberRegex'
import GradientToast from "../gradientToast/Toast"
import toEnglishNumber from "../../helpers/actions/toEnglishNumber"
import disconnectTextGenerator from "../../helpers/actions/disconnectedText"
import {
    ChannelCardToggle, VendorCardToggle, GetChannelList, GetSnappShopVendors, SubmitDelete,
    CompleteProgressBar, GetProgressBar, GetDKRedirectURL, GetDKToken, SubmitAddChannel, SubmitChannelOTP,
    SubmitAddSnappShopChannel, SubmitSnappShopChannelOTP, SyncSnappShopVariants, GetProductListFromDK
} from "../../actions/APIcalls"
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import Skeleton from "./skeleton"
import noPannelEmptyState from '../../assets/icons/EmptyStates/channel_noPanel.svg'
import ChannelModal from './addChannelModal/channelModal'
import GeneralWarning from "../generalWarning/warning"

const Channels = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [loading, setLoading] = useState(false)
    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);
    const [addModal, setAddModal] = useState({
        open: false,
        step: '1',
        value: "",
        err: "",
        passwordValue: "",
        passwordErr: "",
        success: false,
        id: "",
        name: "",
        confirmCode: '',
        confirmCodeErr: '',
        isWaiting: false,
        channelType: { name: 'دیجی‌کالا', value: "DK" }
    });
    const [editModal, setEditModal] = useState({
        open: false,
        step: '1',
        value: "",
        err: "",
        passwordValue: "",
        passwordErr: "",
        success: false,
        confirmCode: '',
        confirmCodeErr: '',
        id: "",
        channelType: { name: 'دیجی‌کالا', value: "DK" }
    });
    const [deleteModal, setDeleteModal] = useState({ open: false, id: "", success: false, step: 0 })
    const [toast, setToast] = useState({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
    const [channelList, setChannelList] = useState({ list: [] });
    const [counter, setCounter] = useState(0)
    const [addChannelPermissionDenied, setAddChannelPermissionDenied] = useState(false)
    const [addChannelPermissionDeniedShow, setAddChannelPermissionDeniedShow] = useState(false)

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    const buttonHandler = (tag, event) => {
        let AddModal = addModal;
        let EditModal = editModal;
        let DeleteModal = deleteModal;
        switch (tag) {
            case "addSubmit":
                submitAddChannel();
                break;

            case "submitCode":
                submitSentCode('add')
                break;

            case "editSubmit":
                submitEditChannel();
                break;

            case "reSubmitCode":
                submitSentCode('edit')
                break;

            case "addCancel":
                AddModal.open = false;
                AddModal.passwordValue = ""
                AddModal.passwordErr = ''
                AddModal.value = ''
                AddModal.channelType = { name: 'دیجی‌کالا', value: 'DK' }
                AddModal.step = '1'
                setAddModal({ ...AddModal });
                setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                break;

            case "editCancel":
                editModal.open = false;
                editModal.passwordValue = ""
                editModal.passwordErr = ''
                editModal.step = '1'
                setEditModal({ ...EditModal });
                setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })

                break;

            case "deleteCancelOne":
                DeleteModal.open = false;
                DeleteModal.step = 0
                setDeleteModal({ ...DeleteModal });
                setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })

                break;
            case "deleteSubmitOne":
                DeleteModal.open = true;
                setDeleteModal({ ...DeleteModal });
                break;
            case "deleteCancelTwo":
                DeleteModal.step = 0
                DeleteModal.open = false;
                setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                setDeleteModal({ ...DeleteModal });
                break;
            case "deleteSubmitTwo":
                submitDelete()
                break
            default:
                break;
        }
    }

    const submitAddChannel = async () => {
        setLoading(true);
        let AddModal = addModal;
        //validation
        if (typeof addModal.value === "undefined" || addModal.value === "") {
            AddModal.err = "تکمیل این فیلد الزامی است!"
            setLoading(false)
        } else {
            if (!EmailRegex(addModal.value) && !PhoneNumberRegex(toEnglishNumber(addModal.value))) {
                AddModal.err = "فرمت ایمیل یا شماره موبایل را اصلاح کنید!"
            } else {
                AddModal.err = "";
            }
            setLoading(false)
        }
        // end validation
        if (AddModal.err || AddModal.passwordErr) {
            setAddModal({ ...AddModal })
            setLoading(false)
        } else {
            let add = addModal
            add.isWaiting = true
            setAddModal({ ...add })
            setAddModal({ ...add })
            let params = {
                username: toEnglishNumber(addModal.value),
            };
            let res;
            if (addModal.channelType.value == "DK") {
                res = await SubmitAddChannel(params, openToast)
            } else {
                res = await SubmitAddSnappShopChannel({ mobile: toEnglishNumber(addModal.value) }, openToast)
            }
            if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                AddModal.isWaiting = false;
                addModal.step = '2'
                setAddModal({ ...AddModal })
                setLoading(false)
            } else {
                if (typeof res !== "undefined" && typeof res.response !== "undefined") {
                    let add = addModal
                    add.isWaiting = false
                    setAddModal({ ...AddModal })
                }
                setLoading(false)
            }
        }
    }

    const submitSentCode = async (type) => {
        setLoading(true);
        let modaldata = type == 'add' ? addModal : editModal;
        if (
            // modaldata.channelType.value == "DK" && 
            (typeof modaldata.confirmCode === "undefined" || modaldata.confirmCode === "")
        ) {
            modaldata.confirmCodeErr = "تکمیل این فیلد الزامی است!"
            setLoading(false)
        } else {
            modaldata.isWaiting = true
            if (type == 'add') {
                setAddModal({ ...modaldata })
            } else {
                setEditModal({ ...modaldata })
            }
            // setAddModal({ ...add })
            // setAddModal({ ...add })
            let params = {
                username: toEnglishNumber(modaldata.value),
                otp: toEnglishNumber(modaldata.confirmCode)
            }
            let res;
            if ((type == 'add' && addModal.channelType.value == "DK") || (type == 'edit' && editModal.channelType.value == "DK")) {
                res = await SubmitChannelOTP(params, openToast)
            }
            if ((type == 'add' && addModal.channelType.value == "snappShop") || (type == 'edit' && editModal.channelType.value == "snappShop")) {
                res = await SubmitSnappShopChannelOTP({ mobile: toEnglishNumber(modaldata.value), code: toEnglishNumber(modaldata.confirmCode) }, openToast)
                await SyncSnappShopVariants()
            }
            if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                modaldata.success = true;
                modaldata.name = res.data.channelName;
                modaldata.isWaiting = false;
                modaldata.step = '1'
                modaldata.value = ''
                modaldata.channelType = { name: "دیجی‌کالا", value: "DK" }
                // complete progressBar
                await handleProgressBar()
                // complete progressBar
                if (type == 'add') {
                    setAddModal({ ...modaldata })
                } else {
                    setEditModal({ ...modaldata })
                }
                setToast({
                    open: true,
                    text: (modaldata.channelType.value == "DK" ? "پنل با موفقیت ثبت شد. برای شروع به کار ربات، اطلاعات هر تنوع را از صفحه تنوع‌ها تکمیل کنید." : "پنل با موفقیت ثبت شد. برای شروع به کار ربات، اطلاعات هر تنوع را از صفحه اسنپ‌شاپ تکمیل کنید."),
                    type: 'success',
                    hasButton: true,
                    buttonText: (modaldata.channelType.value == "DK" ? 'ورود به صفحه تنوع‌ها' : "ورود به صفحه اسنپ‌شاپ"),
                    buttonAction: (modaldata.channelType.value == "DK" ? () => props.history.push('/variants') : () => props.history.push('/snappshop'))
                })
                getChannelList()
                setLoading(false)
            } else {
                if (typeof res !== "undefined" && typeof res.response !== "undefined") {
                    modaldata.isWaiting = false
                    if (type == 'add') {
                        setAddModal({ ...modaldata })
                    } else {
                        setEditModal({ ...modaldata })
                    }
                }
                setLoading(false)
            }
        }
    }

    const submitEditChannel = async () => {
        setLoading(true)
        let edimodal = editModal;
        let params = {
            // channelId: editModal.id,
            username: edimodal.value
            // password: toEnglishNumber(editModal.passwordValue),
            // email: editModal.value
        }
        // let res = await SubmitEditChannel(params, openToast)
        let res
        if (edimodal.channelType.value == "DK") {
            res = await SubmitAddChannel(params, openToast)
        } else {
            res = await SubmitAddSnappShopChannel({ mobile: toEnglishNumber(edimodal.value) }, openToast)
        }
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            edimodal.step = '2';
            setEditModal({ ...edimodal })
            setLoading(false)
            // getChannelList()
        } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
            setLoading(false)
        }
    }

    const getChannelList = async () => {
        setHasSkeleton(true)
        let res = await GetChannelList()
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            setAddChannelPermissionDenied(res.data.can_add_channel)
            let tmp = channelList
            tmp.list = res.data.channelList
            setChannelList({ ...tmp });
        } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
            setToast({ open: true, text: res.response.data.error, type: 'error', hasButton: false, buttonText: '', buttonAction: () => { } })
        }
        if (channelList.list.length > 0) {
            // complete progressBar
            await handleProgressBar()
            // complete progressBar
        }
        await getSnappShopVendors()
        setHasSkeleton(false)
    }

    const getSnappShopVendors = async () => {
        let vendors = await GetSnappShopVendors()
        if (typeof vendors !== "undefined" && typeof vendors.data !== "undefined" && vendors.data.data) {
            let tmp = channelList
            vendors.data.data.map(el => {
                let dummyObject = {
                    _id: el._id,
                    name: el.title,
                    email: el.email,
                    username: el.mobile,
                    active: el.active,
                    type: { value: 'snappShop', name: "اسنپ‌شاپ" },
                    isOnline: (el.is_online && el.is_online == true ? true : false),
                    createTime: '۱۴۰۲/۰۹/۲۷'
                }
                tmp.list.push(dummyObject)
            })
            setChannelList({ ...tmp })
        }
    }

    useEffect(async () => {
        const queryParameters = new URLSearchParams(window.location.search)
        const type = queryParameters.get("authorization_code")
        if (type) {
            await getTokenFromDK(type)
        }
        await getChannelList();
        if (type) {
            let lastId = channelList.list[(channelList.list.length - 1)]._id
            let res = await GetProductListFromDK({ channelId: lastId }, openToast);
            console.log(res, 'res');
        }
    }, [])

    const dropdownHandler = (tag, id, name, type, version) => {
        if (tag === "edit") {
            if (typeof props.user !== "undefined" && props.user.permission.DGPanel.includes("Edit")) {
                setEditModal({ ...editModal, open: true, id: id, value: name, channelType: type, is_version3: version })
                setAddModal({ ...addModal, open: false })
            }
        } else {
            if (typeof props.user !== "undefined" && props.user.permission.DGPanel.includes("Delete")) {
                setEditModal({ ...editModal, open: false })
                setAddModal({ ...addModal, open: false })
                setDeleteModal({ open: true, id: id, success: false, name: name, step: 1 })
                setCounter(5)
            }
        }
    }

    const handleProgressBar = async () => {
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.AddPanel) {
                    await CompleteProgressBar({ stage: 'AddPanel' })
                }
            }
        }
    }

    const DKConnectionV3 = async (type) => {
        let res = await GetDKRedirectURL()
        if (res && res.data) {
            let url = res.data.redirect_url
            window.location.assign(url)
        }
        buttonHandler(`${type}Cancel`)
    }

    const getTokenFromDK = async (params) => {
        let res = await GetDKToken({ authorization_code: params })
        if (res && res.data) {
            await handleProgressBar()
        }
    }

    const onBlureHandler = (tag) => {
        let AddModal = addModal;
        let EditModal = editModal;
        switch (tag) {
            case "addEmail":
                if (typeof addModal.value === "undefined" || addModal.value === "") {
                    AddModal.err = "تکمیل این فیلد الزامی است!"
                    setAddModal({ ...AddModal })

                } else {
                    if (!EmailRegex(addModal.value) && !PhoneNumberRegex(toEnglishNumber(addModal.value))) {
                        AddModal.err = "فرمت ایمیل یا تلفن همراه را اصلاح کنید!"
                        setAddModal({ ...AddModal })
                    } else {
                        AddModal.err = ""
                        setAddModal({ ...AddModal })
                    }
                }

                break;
            case "addPassword":
                if (typeof addModal.passwordValue === "undefined" || addModal.passwordValue === "") {
                    AddModal.passwordErr = "تکمیل این فیلد الزامی است!"
                    setAddModal({ ...AddModal })

                } else {
                    AddModal.passwordErr = ""
                    setAddModal({ ...AddModal })

                }
                break;
            case "editPassword":
                if (typeof editModal.passwordValue === "undefined" || editModal.passwordValue === "") {
                    EditModal.passwordErr = " تکمیل این فیلد الزامی است!"
                    setEditModal({ ...EditModal })

                } else {
                    EditModal.passwordErr = ""
                    setEditModal({ ...EditModal })

                }
                break;
            case "editEmail":
                if (typeof editModal.value === "undefined" || editModal.value === "") {
                    EditModal.err = "تکمیل این فیلد الزامی است!"
                    setEditModal({ ...EditModal })

                } else {
                    if (!EmailRegex(editModal.value) && !PhoneNumberRegex(toEnglishNumber(editModal.value))) {
                        EditModal.err = "فرمت ایمیل یا شماره موبایل را اصلاح کنید!"
                        setEditModal({ ...EditModal })
                    } else {
                        EditModal.err = ""
                        setEditModal({ ...EditModal })
                    }
                }
                break;
            default:
        }
    }

    const onchangeHandler = (tag, event) => {
        let AddModal = addModal;
        let EditModal = editModal;

        switch (tag) {
            case "addEmail":
                AddModal.value = event.target.value;
                setAddModal({ ...AddModal })
                break;
            case "addPassword":
                AddModal.passwordValue = event.target.value;
                setAddModal({ ...AddModal });
                break;

            case "addConfirmCode":
                AddModal.confirmCode = event.target.value;
                setAddModal({ ...AddModal })
                break;
            case "editEmail":
                EditModal.value = event.target.value;
                setEditModal({ ...EditModal })

                break;
            case "editPassword":
                EditModal.passwordValue = event.target.value;
                setEditModal({ ...EditModal });
                break;
            case "editConfirmCode":
                EditModal.confirmCode = event.target.value;
                setEditModal({ ...EditModal });
                break;
            default:

        }
    }

    const onSubmit = () => {

    }

    const ModalContent = (tag) => {
        switch (tag) {
            case "add":
                return <ChannelModal
                    type={"add"}
                    modalData={addModal}
                    DKConnectionV3={DKConnectionV3}
                    buttonHandler={buttonHandler}
                    onchangeHandler={onchangeHandler}
                    onBlureHandler={onBlureHandler}
                    onSubmit={onSubmit}
                />

            case "edit":
                return <ChannelModal
                    type={"edit"}
                    modalData={editModal}
                    DKConnectionV3={DKConnectionV3}
                    buttonHandler={buttonHandler}
                    onchangeHandler={onchangeHandler}
                    onBlureHandler={onBlureHandler}
                    onSubmit={onSubmit}
                />

            case "deleteTwo":
                return <div className={style.contentWrapper}>
                    <p className={style.deleteNote}>آیا از حذف پنل {deleteModal.name} مطمئنید؟</p>
                    <div className={style.moreDeleteNote}>
                        <span className={style.icon}>h</span>
                        <div>
                            <p className={style.desc}>با حذف پنل، تمام اطلاعات و تنظیمات شما پاک شده و قابل بازگشت نیست.
                                می‌توانید به جای حذف پنل، به صورت موقت، پنل خود را غیرفعال کنید.</p>
                            <p className={style.moreDeleteLink} onClick={() => buttonHandler('deleteCancelTwo', '')}>غیرفعال کردن پنل {deleteModal.name}</p>
                        </div>
                    </div>
                    <div className={style.buttonWrapper}>
                        <div className={style.button}>
                            <button
                                className={style.deleteButton}
                                onClick={() => buttonHandler('deleteSubmitTwo', '')}
                            >
                                حذف
                            </button>
                        </div>
                        <div className={style.button}>
                            <Button
                                disabled={false}
                                tag="deleteCancelTwo"
                                type="outline"
                                label="انصراف"
                                onclick={buttonHandler} />
                        </div>
                    </div>
                </div>
            case "deleteOne":
                return <div className={style.contentWrapper}>
                    <p className={style.deleteNote}>آیا از حذف پنل {deleteModal.name} مطمئنید؟</p>
                    <div className={style.moreDeleteNote}>
                        <span className={style.icon}>h</span>
                        <div>
                            <p className={style.desc}>با حذف پنل، تمام اطلاعات و تنظیمات شما پاک شده و قابل بازگشت نیست.
                                می‌توانید به جای حذف پنل، به صورت موقت، پنل خود را غیرفعال کنید.</p>
                            <p className={style.moreDeleteLink} onClick={() => buttonHandler('deleteCancelTwo', '')}>غیرفعال کردن پنل {deleteModal.name}</p>
                        </div>
                    </div>
                    <div className={style.buttonWrapper}>
                        <div className={style.button}>
                            <Button
                                disabled={deleteModal.step === 1 ? true : false}
                                tag="deleteSubmitOne"
                                type="solid"
                                label={counter > 0 ? "(" + toPersianNumber(counter) + ")" + " حذف" : "حذف"}
                                onclick={buttonHandler} />
                        </div>
                        <div className={style.button}>
                            <Button
                                disabled={false}
                                tag="deleteCancelOne"
                                type="outline"
                                label="انصراف"
                                onclick={buttonHandler} />
                        </div>
                    </div>
                </div>
            default: //nothing
        }
    }
    const countDown = async () => {
        setTimeout(() => {
            if (counter > 0) {
                setCounter(counter - 1)
            } else if (counter === 0) {
                setCounter(0);
                let modal = deleteModal;
                modal.step = 2;
                setDeleteModal({ ...modal })
            }

        }, 1000)
    }

    useEffect(() => {
        if (deleteModal.step === 1 && deleteModal.success === false) {
            countDown();
        }
    }, [counter, deleteModal])

    const openToast = (error) => {
        setToast({
            open: true,
            text: error,
            type: 'warning',
            hasButton: false,
            buttonText: '',
            buttonAction: () => { }
        })
        setLoading(false)
    }

    const submitDelete = async () => {
        let params = { channelId: deleteModal.id }
        let res = await SubmitDelete(params, openToast)
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            let DeleteModal = deleteModal;
            DeleteModal.success = true;
            setDeleteModal({ ...DeleteModal })
            setToast({ open: true, text: `پنل ${deleteModal.name} حذف شد.`, type: 'primary', hasButton: false, buttonText: '', buttonAction: () => { } })
            getChannelList()
        }
    }

    const channelCardToggle = async (id, active, type) => {
        let res;
        if (type.value == 'DK') {
            let params = {
                activeStatus: active,
                channelId: id
            }
            res = await ChannelCardToggle(params);
        } else {
            let params = {
                vendorId: id,
                activeStatus: active,
            }
            res = await VendorCardToggle(params);
        }
        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            getChannelList();
        } else if (typeof res !== "undefined" && typeof res.response !== "undefined") {
            setToast({ open: true, text: res.response.data.error, type: 'error', hasButton: false, buttonText: '', buttonAction: () => { } })
        }
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <React.Fragment>
                <Toast
                    type={toast.type}
                    tag="channel"
                    value={toast.open ? true : false}
                    text={toast.text}
                    parentClose={() => {
                        setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                    }}
                    hasButton={toast.hasButton}
                    buttonText={toast.buttonText}
                    buttonAction={toast.buttonAction}
                />
                <Modal
                    tag="addChannelPermissionDenied"
                    value={addChannelPermissionDeniedShow}
                    title=""
                    parentClose={() => {
                        setAddChannelPermissionDeniedShow(false)
                    }}
                >
                    <div className={style.contentWrapper}>
                        <div className={style.delete}>
                            {/* <img alt="" src={check} /> */}
                            <div className={style.addChannelPermissionDeniedIcon}>4</div>
                            <p>.امکان ثبت پنل جدید برای این حساب کاربری وجود ندارد</p>
                            <Button
                                tag="confirm"
                                type="solid"
                                label="تایید"
                                onclick={() => setAddChannelPermissionDeniedShow(false)}
                            />
                        </div>

                    </div>
                </Modal>
                <Modal
                    tag="حذف"
                    value={deleteModal.open ? true : false}
                    title="حذف پنل"
                    parentClose={() => {
                        setDeleteModal({ open: false, passwordValue: "", success: false });
                        setToast({ open: false, text: '', type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                    }}
                >
                    {deleteModal.success ? <div className={style.contentWrapper}>
                        <div className={style.delete}>
                            {/* <img alt="" src={check} /> */}
                            <p>.پنل {deleteModal.name} با موفقیت حذف شد</p>
                            <Button
                                tag="confirm"
                                type="solid"
                                label="تایید"
                                onclick={() => setDeleteModal({ open: false, success: false })}
                            />
                        </div>

                    </div>
                        :
                        (deleteModal.step === 1 ? ModalContent("deleteOne") : ModalContent("deleteTwo"))
                    }
                </Modal>
                <Modal
                    tag="ثبت پنل جدید"
                    value={addModal.open ? true : false}
                    title="ثبت پنل جدید"
                    parentClose={() => {
                        setAddModal({ ...addModal, open: false, passwordValue: "", step: '1', success: false });
                        setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                    }}
                >
                    {addModal.success ? <div className={style.contentWrapper}>
                        <div className={style.success}>
                            <img alt="" src={check} />
                            <p>.کاربر عزیز، پنل {addModal.name} با موفقیت افزوده شد</p>
                            <Button
                                tag="confirm"
                                type="solid"
                                label="تایید"
                                onclick={() => {
                                    setAddModal({ ...addModal, open: false, success: false });
                                    getChannelList();
                                    setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                                }}
                            />
                        </div>
                    </div>
                        :
                        ModalContent("add")}
                </Modal>

                <Modal
                    tag="اتصال مجدد"
                    value={editModal.open ? true : false}
                    title="اتصال مجدد"
                    parentClose={() => {
                        setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } });
                        setEditModal({ ...editModal, open: false, passwordValue: "", step: '1', success: false });
                    }}
                >
                    {editModal.success ? <div className={style.contentWrapper}>
                        <div className={style.success}>
                            <img alt="" src={check} />
                            <p>.کاربر عزیز، تغییرات با موفقیت اعمال شد</p>
                            <Button
                                tag="confirm"
                                type="solid"
                                label="تایید"
                                onclick={() => {
                                    setEditModal({ ...editModal, open: false, success: false });
                                    setToast({ open: false, text: "", type: '', hasButton: false, buttonText: '', buttonAction: () => { } })
                                }}
                            />
                        </div>

                    </div>
                        :
                        ModalContent("edit")}
                </Modal>
                {
                    props.user.expiredAccount && <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {
                    props.user.disconnected.status &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل‌های فروش به‌روز رسانی کنید</p>
                                <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل‌های فروش  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {/*<div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <GeneralWarning />
                    </GradientToast>
                </div>*/}

                <div className={style.header}>
                    <div className={style.addChannelWrapper}>
                        <div className={style.newChannelButton}>
                            <Button disabled={false} tag="add" type="solid" label="ثبت پنل جدید"
                                onclick={() => {
                                    if (addChannelPermissionDenied) {
                                        if (typeof props.user !== "undefined" && props.user.permission.DGPanel.includes("Add")) {
                                            setAddModal({ ...addModal, open: !addModal.open });
                                            setEditModal({ ...editModal, open: false });
                                        }
                                        setAddChannelPermissionDeniedShow(false)
                                    } else {
                                        setAddModal({ ...addModal, open: !addModal.open });
                                    }

                                }} />
                        </div>
                    </div>
                    <p className={style.mainTitle}>پنل‌های فروش</p>
                </div>
                <div className={style.mainWrapper}>
                    {channelList && channelList.list.length > 0 ?
                        <div className={style.frame}>
                            <div className={style.desktop}>
                                <div className={style.hiddenListShadow}></div>
                                <div className={style.logListWrapper}>
                                    <div className={offset > 480 ? style.listHeaderFixed : style.listHeader}>
                                        <div className={style.listHeaderItem24}></div>
                                        <div className={style.listHeaderItem215}>نام پنل</div>
                                        <div className={style.listHeaderItem48}>وضعیت</div>
                                        <div className={style.listHeaderItem88}>تاریخ ثبت</div>
                                        <div className={style.listHeaderItem100}>ارتباط با پنل</div>
                                        <div className={style.listHeaderItem113}></div>
                                    </div>
                                    <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                                    <div className={style.channelCardsWrapper}>
                                        {channelList.list.map((i, index) => <div className={style.listWrapper} key={index}>
                                            <ChannelsCard
                                                data={i}
                                                type={i.type ? i.type : { value: "DK", name: "دیجی‌کالا" }}
                                                dropdown={dropdownHandler}
                                                toggleHandlerParent={channelCardToggle}
                                                updateChannels={() => getChannelList()}
                                            />
                                        </div>)}
                                    </div>
                                </div>
                            </div>
                            <div className={style.mobile}>
                                {channelList.list.map((i, index) => <div className={style.listWrapper} key={index}>
                                    <MobileChannelsCard
                                        data={i}
                                        type={i.type ? i.type : { value: "DK", name: "دیجی‌کالا" }}
                                        dropdown={dropdownHandler}
                                        toggleHandlerParent={channelCardToggle}
                                        updateChannels={() => getChannelList()}
                                    />
                                </div>)}
                            </div>
                        </div>
                        :
                        <div className={style.wrapper}>
                            <div className={style.emptyList}>
                                <div className={style.imageWrap}>
                                    <img src={noPannelEmptyState} />
                                </div>
                                <p>می‌تونید پنل‌های فروش‌تون رو اینجا ثبت کنید</p>
                                <p className={style.bold}>با ثبت پنل، تنوع‌های شما به صورت خودکار از پنل فروش دریافت می‌شه</p>
                                <div className={style.addChannelWrapperSecond}>
                                    <Button
                                        disabled={false}
                                        tag="add"
                                        type="solid"
                                        label="ثبت پنل جدید"
                                        onclick={() => {
                                            if (typeof props.user !== "undefined" && props.user.permission.DGPanel.includes("Add")) {
                                                setAddModal({ ...addModal, open: !addModal.open });
                                                setEditModal({ ...editModal, open: false });
                                            }
                                        }} />
                                    <Button
                                        disabled={false}
                                        tag="guide"
                                        type="outline"
                                        label="ویدئوهای آموزشی"
                                        onclick={() => props.history.push('/guide')}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </React.Fragment>
        )
    }
}
export default withRouter(Channels)